import { archivePolicyMenuGroupHeaderText } from './generateArchivePolicyList.locstring.json';
import loc from 'owa-localize';
import ElcFolderType from 'owa-service/lib/contract/ElcFolderType';
import RetentionPolicyTag from 'owa-service/lib/contract/RetentionPolicyTag';
import RetentionTagType from 'owa-service/lib/contract/RetentionTagType';
import { IContextualMenuItem, ContextualMenuItemType } from '@fluentui/react/lib/ContextualMenu';
import createSubMenuItem from './createSubMenuItem';
import { ARCHIVE_INHERIT_SUBMENU_ITEM_IDENTIFIER } from './retentionPolicyConstants';
import createInheritSubMenuItem from './createInheritSubMenuItem';

const styles = require('./SubMenuItem.scss');

/**
 * Utility to generate the archive retention policy list
 * @param archiveRetentionPolicyTagList archive policy retention tag list which are to be shown
 * @param showTagSelection whether to show a selected sub menu item as checked
 * @param currentArchivePolicyTag currently selected archive tag
 * @param folderType
 * @param onArchivePolicyClickCallback
 */
export default function generateArchivePolicyList(
    archiveRetentionPolicyTagList: RetentionPolicyTag[],
    showTagSelection: boolean,
    currentArchivePolicyTag: RetentionTagType,
    folderType: ElcFolderType,
    onArchivePolicyClickCallback: (
        ev: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item: IContextualMenuItem
    ) => void
): IContextualMenuItem[] {
    const currentArchivePolicyValue = currentArchivePolicyTag?.IsExplicit
        ? currentArchivePolicyTag.Value
        : null;
    return [
        {
            key: 'archiveSection',
            className: styles.sectionHeader,
            itemType: ContextualMenuItemType.Section,
            sectionProps: {
                bottomDivider: true,
                title: loc(archivePolicyMenuGroupHeaderText),
                items: getArchiveListItemsFromPolicyTags(
                    archiveRetentionPolicyTagList,
                    showTagSelection,
                    currentArchivePolicyValue,
                    folderType,
                    onArchivePolicyClickCallback
                ),
            },
        },
    ];
}

function getArchiveListItemsFromPolicyTags(
    retentionPolicyTagList: RetentionPolicyTag[],
    showTagSelection: boolean,
    currentArchivePolicyValue: string,
    folderType: ElcFolderType,
    onArchivePolicyClickCallback: any
): IContextualMenuItem[] {
    let selectedPolicyFound = false;
    // We only display the default archive policy for root folder node ( ElcFolderType.All represents root node).
    const initialListItems =
        folderType == ElcFolderType.All
            ? []
            : retentionPolicyTagList.map(tag => {
                  const isSelected = tag.RetentionId === currentArchivePolicyValue;
                  if (isSelected) {
                      selectedPolicyFound = true;
                  }
                  return createSubMenuItem({
                      retentionId: tag.RetentionId,
                      displayName: tag.DisplayName,
                      isChecked: showTagSelection && isSelected,
                      subMenuProps: null,
                      onClickCallback: onArchivePolicyClickCallback,
                  });
              });
    return initialListItems.concat(
        createInheritSubMenuItem({
            retentionId: ARCHIVE_INHERIT_SUBMENU_ITEM_IDENTIFIER,
            retentionPolicyTags: retentionPolicyTagList,
            folderType: folderType,
            isArchive: true,
            isChecked: showTagSelection && !selectedPolicyFound,
            onClickCallback: onArchivePolicyClickCallback,
        })
    );
}
